import React from 'react';
import App from 'App';
import paths, { rootPaths } from './paths.js';
import { createBrowserRouter } from 'react-router-dom';
import MainLayout from 'layouts/MainLayout.js';
import Cities from 'pages/Configuration/Cities.js';
import Dashboard from 'pages/Dashboards/DashboardIndex.js';
import Logout from 'componentes/authentication/simple/Logout.js';
import Login from 'pages/Account/Login.js';
import TiposProductoQueja from 'pages/Configuration/TiposProductoQueja.js';

import TiposStatus from 'pages/Configuration/TiposStatus.js';
import Status from 'pages/Configuration/Status.js';
import CodigosPostales from 'pages/Configuration/CodigosPostales.js';
import ClasificacionesQueja from 'pages/Administration/ClasificacionesQueja.js';
import DelegacionesProfeco from 'pages/Administration/DelegacionesProfeco.js';
import Customers from 'pages/Administration/Customers.js';
import DetailCustomer from 'pages/Administration/DetailCustomer.js';
import Noms from 'pages/Configuration/Noms.js';
import NewQueja from 'pages/Operations/NewQueja.js';
import QuejaDetail from 'pages/Operations/QuejaDetail.js';
import Users from 'pages/Account/Users.js';
import TiposPlataforma from 'pages/Configuration/TiposPlataforma.js';
import FormatosQueja from 'pages/Administration/FormatosQueja.js';
import Calendar from 'pages/Dashboards/Calendar.js';
import DashboardOpen from 'pages/Dashboards/DashboardOpen.js';
import ReporteQuejas from 'pages/Reportes/ReporteQuejas.js';
import TiposEventos from 'pages/Configuration/TiposEventos.js';
import AddQueja from 'pages/Operations/AddQueja.js';
import CalendarWeek from 'pages/Dashboards/CalendarWeek.js';
import Determinantes from 'pages/Administration/Determinantes.js';
import ClasificacionesQuejaWm from 'pages/Administration/ClasificacionesQuejaWm.js';
import { ProtectedRoutes } from 'context/ProtectedRoutes.js';
import ClasificacionesQuejaProfeco from 'pages/Administration/ClasificacionesQuejaProfeco.js';
import ReporteQuejasPeriodo from 'pages/Reportes/ReporteQuejasPeriodo.js';

const routes = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: (
          <ProtectedRoutes>
            <MainLayout />
          </ProtectedRoutes>
        ),
        children: [
          {
            index: true,
            path: paths.DashboardAbiertas,
            element: <DashboardOpen />
          },
          {
            index: true,
            element: <Dashboard />
          },
          {
            index: true,
            path: paths.Calendario,
            element: <Calendar />
          },
          {
            index: true,
            path: paths.CalendarioSem,
            element: <CalendarWeek />
          },

          {
            path: rootPaths.quejasRoot,
            children: [
              {
                index: true,
                path: paths.AddQueja,
                element: <AddQueja />
              },
              {
                index: true,
                path: paths.NewQueja,
                element: <NewQueja />
              },
              {
                index: true,
                path: paths.QuejaDetails,
                element: <QuejaDetail />
              }
            ]
          },
          {
            path: rootPaths.administationRoot,
            children: [
              {
                index: true,
                path: paths.Customers,
                element: <Customers />
              },

              {
                index: false,
                path: paths.DetailCustomer,
                element: <DetailCustomer />
              },
              {
                path: paths.ClasificacionQueja,
                element: <ClasificacionesQueja />
              },
              {
                path: paths.ClasificacionQuejaProfeco,
                element: <ClasificacionesQuejaProfeco />
              },
              {
                path: paths.ClasificacionQuejaWm,
                element: <ClasificacionesQuejaWm />
              },
              {
                path: paths.FormatosQueja,
                element: <FormatosQueja />
              },
              {
                path: paths.Determinantes,
                element: <Determinantes />
              },
              {
                path: paths.DelegacionesProfeco,
                element: <DelegacionesProfeco />
              }
            ]
          },
          {
            path: rootPaths.reportesRoot,
            children: [
              {
                index: true,
                path: paths.ReporteQuejas,
                element: <ReporteQuejas />
              },
              {
                index: true,
                path: paths.ReporteQuejasPeriodo,
                element: <ReporteQuejasPeriodo />
              }
            ]
          },
          {
            path: rootPaths.configurationRoot,
            children: [
              {
                path: paths.Cities,
                element: <Cities />
              },
              {
                path: paths.CodigosPostales,
                element: <CodigosPostales />
              },
              {
                path: paths.Noms,
                element: <Noms />
              },
              {
                path: paths.TiposProductoQueja,
                element: <TiposProductoQueja />
              },
              // {
              //   path: paths.TiposViolacion,
              //   element: <TiposViolacion />
              // },
              {
                path: paths.TiposEventos,
                element: <TiposEventos />
              },
              {
                path: paths.TiposStatus,
                element: <TiposStatus />
              },
              {
                path: paths.TiposPlataforma,
                element: <TiposPlataforma />
              },
              {
                path: paths.Status,
                element: <Status />
              }
            ]
          },

          {
            path: rootPaths.authRoot,
            children: [
              {
                path: paths.Users,
                element: <Users />
              }
            ]
          }
        ]
      },
      {
        path: rootPaths.authRoot,
        children: [
          {
            path: paths.simpleLogout,
            element: <Logout />
          },
          {
            path: paths.simpleLogin,
            element: <Login />
          }
        ]
      }
    ]
  }
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL
});

export default routes;
